<template lang="pug">
  .Paragraph.Paragraph-margin.ParagraphVisuals
    .ParagraphVisuals_wrapper
      template(v-if="hasMultipleVisuals")
        MediaCarousel(
          :items="item.visuals"
          itemTitleProperty="title")
          template(slot-scope="{ item }")
            AdaptativeImg(:derivatives="item.derivatives" :type="'block'" :fit="false" :name="item.title")

      template(v-if="hasOnlyOneVisual")
        .ParagraphVisuals_cache
        AdaptativeImg(:derivatives="firstVisual.derivatives" :type="'cover'" :fit="false" :name="firstVisual.title")
        MediaLegend(
          :items="[firstVisual.title]")
</template>

<script>

import MediaLegend from '@/components/MediaLegend'
import AdaptativeImg from '@/components/common/AdaptativeImg'
import MediaCarousel from '@/components/MediaCarousel'
import scrollUpdate from '@/mixins/scrollUpdate'

export default {
  components: {
    MediaLegend,
    MediaCarousel,
    AdaptativeImg
  },
  props: ['item'],
  mixins: [scrollUpdate],
  methods: {
    onProgress (p, pv) {
      this.percent = Math.round(p * 100) / 100
      this.percentV = Math.round(pv * 100) / 100

      if (this.percentV >= 0.2) {
        this.$el.classList.add('is-visible')
      } else {
        this.$el.classList.remove('is-visible')
      }
    }
  },
  computed: {
    hasOnlyOneVisual () {
      return this.item.visuals.length === 1
    },
    hasMultipleVisuals () {
      return this.item.visuals.length > 1
    },
    firstVisual () {
      return this.item.visuals[0]
    }
  }
}
</script>

<style lang="stylus" scoped>

.ParagraphVisuals

  position relative

  &_wrapper
    width 100%

  picture
    display: block
    width 100%
    height auto

  &_cache

    height 100%
    width 100%
    background-color $black
    position absolute
    top 0px
    left 0px
    transition opacity 0.8s $ease

  &.is-visible

    .ParagraphVisuals_cache

      opacity 0

</style>
